<template>
    <div
        :class="[
            borderStyle[border as keyof typeof borderStyle],
            colorStyle[color as keyof typeof colorStyle],
            'flex flex-col gap-4',
            $attrs.class,
        ]">
        <header>
            <p v-if="subTitle" class="mb-4">{{ subTitle }}</p>
            <h3 v-if="title" class="font-title text-3xl lg:text-4xl">{{ title }}</h3>
        </header>
        <div v-if="tags && tags?.length > 0" class="flex flex-wrap gap-2">
            <NuxtLink
                v-for="chip in tags"
                :key="chip.title"
                :to="chip.slug ? localeRoute(chip.slug) : undefined"
                class="is-disabled"
                :class="chipStyle[color as keyof typeof colorStyle]">
                {{ chip.title }}
            </NuxtLink>
        </div>
        <div v-if="body" class="flex flex-col" v-html="body" />
        <div v-if="logos" class="flex flex-wrap gap-4">
            <img
                v-for="logo in logos"
                :key="logo.url"
                height="30"
                class="h-7.5"
                :src="logo.url + '?height=30&format=webp'"
                :alt="logo.alt ?? undefined" />
        </div>
        <footer v-if="buttons" class="mt-auto flex flex-wrap gap-2">
            <NuxtLink
                v-for="(link, index) in buttons"
                :key="`${link.title}-${index}`"
                :to="localeRoute(link.url)"
                :class="index === 0 ? 'btn-secondary-a' : 'btn-primary-a'"
                :target="link.openInNewTab ? '_blank' : '_self'">
                {{ link.title }}
            </NuxtLink>
        </footer>
    </div>
</template>

<script lang="ts" setup>
import type { TextBlockComponentModel } from '@su4r-frontend/api';
const { border = 'none', color = 'light' } = defineProps<TextBlockComponentModel>();
const localeRoute = useLocaleRoute();
const borderStyle = {
    'none': 'tile',
    'bottom-left': 'tile-bottom-left',
    'top-right': 'tile-top-right',
};

const colorStyle = {
    light: 'bg-blue-light',
    medium: 'bg-blue-medium',
    transparent: 'tile-blur',
    white: 'bg-white',
};

const chipStyle = {
    light: 'chip-dark',
    medium: 'chip-dark',
    transparent: 'chip-light',
    white: 'chip-dark',
};
</script>
